export default __webpack_public_path__ + "static/media/ctt-logo.6f0c6fe8.svg";